/**
 * 注意：
 * 点击事件防抖
 * 使用方法如下：
 */

const debounceClick = {
  inserted(el, binding, vnode) {},
  update(el) {},
  unbind(el) {}
};

export default debounceClick;
